// Single shared volume knob for all app-generated audio (TTS + beep).
// Change MASTER_VOLUME to raise/lower both together; BEEP_GAIN_RATIO keeps
// the beep's relative loudness matched to the TTS voice.
export const MASTER_VOLUME = 1;
// Beep peak level relative to MASTER_VOLUME. The beep now holds at this level for
// most of its duration (see playBeep) rather than decaying instantly, so it reads
// at a similar loudness to the TTS. Lower this if the beep is too loud.
export const BEEP_GAIN_RATIO = 0.8;
